import BaseModel from '../core/BaseModel'
export default class CompanyModel extends BaseModel {
    constructor() {
        super({
            tableName: 'company', label: "Danh sách công ty", display_key: 'name'
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              width: 5,
              class: 'center', 
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID',
              width: 7,
              primaryKey: true,  
              display: false
            },
            logo : {
              name: 'logo', 
              type: "Image", 
              label: 'Logo',
              width: 7
            },
            name : {
              name: 'name', 
              type: "Text", 
              label: 'Tên công ty',
              width: 13,
              filter: {type: 'input', match: 'contains'},
            },
            username : {
              name: 'username', 
              type: "Text", 
              label: 'Tên đăng nhập',
              width: 13,
              filter: {type: 'input', match: 'contains'},
            },
            fullname : {
              name: 'fullname', 
              type: "Text", 
              label: 'Người đại diện',
              width: 13,
              filter: {type: 'input', match: 'contains'},
            },
            phone : {
              name: 'phone', 
              type: "Text", 
              label: 'Số điện thoại',
              width: 7,
              filter: {type: 'input', match: 'contains'},
            },
            users : {
              name: 'users', 
              type: "CustomUrl", 
              label: 'SL user',
              width: 5,
              class: 'center',
              computed: (data) => {
                data.users = 0;
              }
            },
            status : {
              name: 'status', 
              type: "Selection", 
              label: 'Trạng thái',
              width: 7,
              options: [{
                label: "Đang hoạt động",
                value: 1
              },{
                label: "Đã hết hạn",
                value: 0
              }],
              filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            expiration_date : { 
              name: 'expiration_date', 
              type: "Datetime", 
              label: 'Ngày hết hạn',
              width: 7,
              filter: { type: 'DateRange', match: 'contains'},
            },
            updated_at : { 
              name: 'updated_at', 
              type: "Datetime", 
              label: 'Cập nhật cuối',
              width: 7,
              filter: { type: 'DateRange', match: 'contains'},
            },
            created_at : { 
              name: 'created_at', 
              type: "Datetime", 
              label: 'Ngày tạo',
              filter: { type: 'DateRange', match: 'contains'},
              display : false
            },
            deleted: {
              name: "deleted",
              label: "Xóa",
              type: "Checkbox",
              display: false
            }
        })
    }

}